var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{attrs:{"inline":"","left":"","bordered":"","dot":"","color":"caution"}})}
var staticRenderFns = []

export { render, staticRenderFns }